import { render, staticRenderFns } from "./regulatoryCategory.vue?vue&type=template&id=05b0a7b8&scoped=true"
import script from "./regulatoryCategory.vue?vue&type=script&lang=js"
export * from "./regulatoryCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b0a7b8",
  null
  
)

export default component.exports